<template>
  <div>
    <b class='hide'>#{{item.id}}</b>
     <span>{{ item.name }}: {{ item.deviceType.name }}</span>
     <abbr>{{ item.solarKitIds }}</abbr>
     
    <!-- <abbr>{{item.description}}</abbr> -->
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/utils/ItemTemplate.vue